import { render, staticRenderFns } from "./AboutPropsBlock.vue?vue&type=template&id=2720d458"
import script from "./AboutPropsBlock.vue?vue&type=script&lang=js"
export * from "./AboutPropsBlock.vue?vue&type=script&lang=js"
import style0 from "./AboutPropsBlock.vue?vue&type=style&index=0&id=2720d458&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports